var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracey-route-page",style:(_vm.pageLayoutStyle)},[_c('tracey-page-chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }